import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import JournalEventForm from '../../../components/admin/journal/JournalEventForm'
import JournalEventTable from '../../../components/admin/journal/JournalEventTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const JournalEventPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PUBLISHERS])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <JournalEventForm />
      </Box>
      <Box paddingTop={3}>
        <JournalEventTable />
      </Box>
    </Box>
  )
}

export default React.memo(JournalEventPage)
